import "core-js/modules/es.object.assign.js";
import * as doT from 'dot';

/**
 * Generates HTML from a template and data
 * @param  {String} tpl   Name of the list to loop in
 * @param  {Object} dat   Data to use to generate template
 * @Return  {String}      Return generated template
 */
export var template = function template(tpl, data) {
  // if tpl is already compiled in cache, serve it
  if (tpl in cache) {
    return cache[tpl](data);
  }

  // if cache doesn't exist, create and store it
  var tmp = doT.template(tpl);
  var obj = {};
  obj[tpl] = tmp;
  Object.assign(cache, obj);
  return tmp(data);
};

// Compile is the most expensive task, so we cache the result
var cache = {};